// extracted by mini-css-extract-plugin
export default {"container":"Header_container__gVk2h","title":"Header_title__jVEmM"};